export default [
  { value: 'f1', label: 'USD$0 - USD$15.000' },
  { value: 'f2', label: 'USD$15.001 - USD$35.000' },
  { value: 'f3', label: 'USD$35.001 - USD$50.000' },
  { value: 'f4', label: 'USD$50.001 - USD$100.000' },
  { value: 'f5', label: 'USD$100.001 - USD$400.000' },
  { value: 'f6', label: '> USD$400.000' },
];



// WEBPACK FOOTER //
// ./src/utils/selectors/BudgetOptions.js